import React from 'react';

import { AddressDisplay } from './address-display';
import { AssetHeader } from './asset-header';
import { PersonalInfoSection } from './personal-info-section';
import { ValueDisplay } from './value-display';

interface Debtor {
  firstName: string;
  lastName: string;
  amountOwed: number;
  description: string;
  address: {
    address1: string;
    address2?: string;
    city: string;
    state: string;
    zip: string;
  };
}

interface DebtorListProps {
  debtors: Debtor[];
}

export function DebtorList({ debtors }: DebtorListProps) {
  return (
    <div className="asset-list">
      {debtors.map((debtor, index) => (
        <div key={index} className="asset-detail">
          <AssetHeader asset={{ name: `${debtor.firstName} ${debtor.lastName}`, type: 'debtor' }} />
          <PersonalInfoSection label="Address" verified={false} value={<AddressDisplay address={debtor.address} />} />
          <div className="value-display-container">
            <ValueDisplay label="Amount Owed" value={String(debtor.amountOwed)} />
            <ValueDisplay label="Description" value={debtor.description} />
          </div>
        </div>
      ))}
    </div>
  );
}
